import { render, staticRenderFns } from "./top.vue?vue&type=template&id=1220aed0&scoped=true&"
import script from "./top.vue?vue&type=script&lang=js&"
export * from "./top.vue?vue&type=script&lang=js&"
import style0 from "./top.vue?vue&type=style&index=0&id=1220aed0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1220aed0",
  null
  
)

export default component.exports